import { Box, Button } from "@mui/material";
import React from "react";
import CustomTextField from "../components/formControls/CustomTextField";
import { RendererType } from "../types/enums/enums";
import { SubmitHandler, useForm } from "react-hook-form";
import CustomTextArea from "../components/formControls/CustomTextArea";

const SendFeedback = () => {
  const profileDetailForm = useForm<any>();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = profileDetailForm;

  const onSubmit: SubmitHandler<any> = (formData) => {
    console.log("Submitted Data : ", formData);
  };

  return (
    <Box className="rounded-[30px] md:mx-[45px] md:mt-8 p-[30px] bg-white flex-column gap-7">
      <form className="flex-column gap-7">
        <Box className="gap-5 flex-column">
          <CustomTextField
            label="Title"
            name="title"
            required
            placeholder="Enter Title"
            type={RendererType.string}
            control={control}
            errors={errors.title?.message?.toString()}
            rules={{
              required: "Title is Required",
            }}
          />
          <CustomTextArea
            name="description"
            label="Description"
            rows={3}
            placeholder="Enter Description"
            type={RendererType.textarea}
            control={control}
            errors={errors.description?.message?.toString()}
          />
        </Box>
        <Box>
          <Button
            onClick={handleSubmit(onSubmit)}
            className="w-min !px-5 !py-2 !capitalize !bg-primary-blue-950 !text-white !rounded-lg"
          >
            Submit
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default SendFeedback;
